'use strict';
import _ from 'underscore';
import angular from 'angular';
var DropShipShippingAddressListController = /** @class */ (function () {
    /*@ngInject*/
    function DropShipShippingAddressListController($log, $scope, $mdDialog, Util, DropShipShippingAddressListService, Auth) {
        this.sortType = '';
        this.sortReverse = false;
        this.searchDropShipAddress = '';
        this.shippingAddresses = [];
        this.dropShipAddresses = [];
        this.shipAddressIdToDelete = null;
        // set the default amount of items being displayed
        this.limit = 10;
        this.showViewMore = false;
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        this.showAlert = false;
        // loadMore function
        // loadMore = function() {
        //   var incremented = this.limit + 10;
        //   this.limit = incremented > this.dropShipAddresses.totalResults ? this.dropShipAddresses.totalResults : incremented;
        //   console.log('Limit is..' + this.limit);
        //   if (incremented > this.dropShipAddresses.totalResults) {
        //     this.showViewMore = false;
        //   } else {
        //     this.showViewMore = true;
        //   }
        // }
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.shippingAddressBeingEdited = null;
        this.isLoggedIn = function () {
            if (this.loggedInUser) {
                return true;
            }
            return false;
        };
        this.$log = $log;
        this.$scope = $scope;
        this.dropShipShippingAddressListService = DropShipShippingAddressListService;
        this.$scope.shippingAddress = {};
        this.$scope.addressDetails = {};
        this.$mdDialog = $mdDialog;
        this.action = 'None';
        this.Auth = Auth;
        this.Util = Util;
        var self = this;
        this.pageModel = {
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            pages: [1]
        };
        this.currentSearchTerm = '';
        self.refresh(1);
        this.Auth.isLoggedIn(function (loggedInUser) {
            if (loggedInUser) {
                self.$log.debug('In shipping..current user is..', loggedInUser);
                self.loggedInUser = loggedInUser;
            }
        });
        $scope.$on('AddressAddedEvent', function (event, data) {
            console.log('In AddressAddedEvent 1');
            self.afterAddingNewShippingAddress(data);
        });
        $scope.$on('updatedAddress', function (event, data) {
            self.$log.debug('In drop ship updateAddress address updated is......', data);
            self.updateAddressDetails(data);
            self.shippingAddressBeingEdited = null;
        });
    }
    DropShipShippingAddressListController.prototype.updatePageModel = function (response) {
        // calculate total pages
        this.pageModel.totalPages = Math.ceil(response.totalResults / this.pageModel.pageSize);
        this.pageModel.pages = _.range(1, this.pageModel.totalPages + 1);
    };
    DropShipShippingAddressListController.prototype.refresh = function (pageNumber) {
        var self = this;
        self.dropShipShippingAddressListService.getDropShipAddresses(pageNumber, this.pageModel.pageSize)
            .then(function (response) {
            if (response.status != 200 || response.data.errors.length) {
                self.Util.handleApiError(response, self);
            }
            else {
                self.dropShipAddresses = response.data.response;
                self.updatePageModel(self.dropShipAddresses);
                self.Util.resetApiError(self);
            }
        });
    };
    DropShipShippingAddressListController.prototype.pageChanged = function () {
        if (this.findAddress == '' || this.findAddress == undefined) {
            this.refresh(this.pageModel.currentPage);
        }
        else {
            this.findPatientAddress(null, this.findAddress, this.pageModel.currentPage);
        }
    };
    DropShipShippingAddressListController.prototype.afterAddingNewShippingAddress = function (response) {
        var self = this;
        var newShippingAddress = response.data.response;
        self.refresh();
        self.shippingAddressBeingEdited = null;
        if (self.dropShipAddresses.currentPage) {
            self.dropShipAddresses.currentPage.unshift(newShippingAddress);
        }
        self.closeDialog();
        self.action = 'None';
        self.Util.resetApiError(self);
    };
    DropShipShippingAddressListController.prototype.closeDialog = function () {
        this.$mdDialog.hide();
    };
    DropShipShippingAddressListController.prototype.updateAddressDetails = function (data) {
        var self = this;
        for (var i in self.dropShipAddresses.currentPage) {
            if (self.dropShipAddresses.currentPage[i].addressKey == data.addressKey) {
                //This credit card details is updated; so update the list.
                self.$log.debug('Found the drop ship Address to be updated for this address!');
                //Update only the changed fields so that entire address form doesn't refresh(blink)
                Object.keys(self.dropShipAddresses.currentPage[i]).forEach(function (key) {
                    if (self.dropShipAddresses.currentPage[i][key] !== data[key]) {
                        self.dropShipAddresses.currentPage[i][key] = data[key];
                    }
                });
                break; //Stop this loop, we found it!
            }
        }
    };
    DropShipShippingAddressListController.prototype.editShippingAddress = function (shippingAddressId) {
        console.log('in editShippingAddress -> ', shippingAddressId);
        this.shippingAddressBeingEdited = shippingAddressId;
    };
    DropShipShippingAddressListController.prototype.deleteShippingAddress = function (shippingAddress) {
        var self = this;
        console.log('Deleting ShippingAddresse -> ', this.dropShipAddresses);
        this.dropShipAddresses.currentPage = this.dropShipAddresses.currentPage.filter(function (x) {
            return x.addressId != shippingAddress.addressId;
        });
        console.log('Deleting ShippingAddresse -> ', shippingAddress);
        this.dropShipShippingAddressListService.deleteAddress(shippingAddress.addressId)
            .then(function (response) {
            self.$log.debug('After deleting shipping address response is...', response);
            if (response.status != 200 || response.data.errors.length) {
                self.Util.handleApiError(response, self);
            }
            else {
                self.Util.resetApiError(self);
            }
        });
    };
    DropShipShippingAddressListController.prototype.submitForm = function () {
        this.action = 'Add';
        this.$scope.$broadcast('submitForm', {});
    };
    DropShipShippingAddressListController.prototype.findPatientAddress = function (evt, searchTerm, pageNumber) {
        var _this = this;
        var self = this;
        if (!evt || evt.key == 'Enter' || evt.type == 'click') {
            this.dropShipShippingAddressListService.findDropShipAddressesBySearchTerm(searchTerm, pageNumber, self.pageModel.pageSize)
                .then(function (response) {
                if (response.status != 200 || response.data.errors.length) {
                    self.Util.handleApiError(response, self);
                }
                else {
                    _this.dropShipAddresses = response.data.response;
                    if (searchTerm != "" && searchTerm !== self.currentSearchTerm) {
                        self.pageModel.currentPage = 1;
                    }
                    self.currentSearchTerm = searchTerm;
                    self.updatePageModel(self.dropShipAddresses);
                    self.Util.resetApiError(self);
                }
            });
        }
    };
    DropShipShippingAddressListController.prototype.isFormValid = function () {
        if (this.isAddressFormValid) {
            return true;
        }
        return false;
    };
    DropShipShippingAddressListController.prototype.setDeleteAddressIndex = function (id) {
        this.shipAddressIdToDelete = this.shipAddressIdToDelete == id ? null : id;
    };
    DropShipShippingAddressListController.prototype.cancelDelete = function () {
        this.shipAddressIdToDelete = null;
    };
    DropShipShippingAddressListController.prototype.showAddress = function (ev, templateName, toShowDefault) {
        var self = this;
        console.log('Received ShowDefault -> ', toShowDefault);
        //contentElement: '#' + templateName,
        self.$mdDialog.show({
            controller: this.DialogController,
            resolve: {
                parentScope: function () {
                    return self.$scope;
                },
                showDefault: function () {
                    return toShowDefault;
                }
            },
            templateUrl: templateName,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        })
            .then(function (answer) {
            console.log('Answer in showAddress is ->', answer);
        }, function () {
            self.$log.debug('You cancelled the dialog.');
        });
    };
    ;
    /*@ngInject*/
    DropShipShippingAddressListController.prototype.DialogController = function ($scope, $mdDialog, DropShipShippingAddressListService, Util, parentScope, showDefault) {
        this.$scope = $scope;
        this.$scope.dropShipShippingAddressListService = DropShipShippingAddressListService;
        var self = this;
        var isAddressFormValid;
        var formSubmitted = false;
        var action = 'None';
        this.Util = Util;
        this.$scope.addressDetails = {};
        this.$scope.toShowDefault = showDefault;
        console.log('In DialogController');
        $scope.$on('addressFormValid', function (event, data) {
            console.log('AddressFormValid Event Received ->', data);
            isAddressFormValid = data;
        });
        //Child component address-form  will send this message.
        $scope.$on('publishedAddress', function (event, data) {
            self.$scope.shippingAddress = data;
            self.$scope.shippingAddress.recipientName = self.$scope.addressDetails.recipientName;
            self.$scope.shippingAddress.isDefault = self.$scope.addressDetails.isDefault;
            self.$scope.shippingAddress.addressKey = self.$scope.addressDetails.addressKey;
            console.log('In DropShip publishedAddress ', self.$scope.shippingAddress);
        });
        $scope.$on('AddressDetailsChanged', function (event, data) {
            console.log('In AddressDetailsChanged -> ', data);
            var details = {};
            details["recipientName"] = data.recipientName;
            details["isDefault"] = data.isDefault;
            details["addressKey"] = self.$scope.addressDetails.addressKey;
            self.$scope.addressDetails = details;
            console.log('In DropShip AddressDetailsChanged ', self.$scope.addressDetails);
        });
        this.$scope.$watchGroup(['shippingAddress', 'addressDetails'], function (newValue, oldValue, scope) {
            console.log('In watchgroup 1 ', action);
            if (action === 'Add' && newValue[0] != oldValue[0] && newValue[1] != oldValue[1]) {
                console.log('In watchgroup 2');
                var address = newValue[0];
                var addressDetails = newValue[1];
                address.recipientName = addressDetails.recipientName;
                address.isDefault = addressDetails.isDefault;
                console.log('In watchgroup 2 address ->', address);
                addNewShippingAddress(address);
            }
        });
        $scope.isFormValid = function () {
            return (isAddressFormValid && !formSubmitted);
        };
        $scope.submitForm = function () {
            action = 'Add';
            $scope.$broadcast('submitForm', {});
        };
        var addNewShippingAddress = function (address) {
            console.log('Add this drop Ship Address:', address);
            self.$scope.dropShipShippingAddressListService.addShippingAddress(address)
                .then(function (response) {
                console.log('After adding drop ship address, response is...', response);
                if (response.status != 200 || response.data.errors.length) {
                    self.Util.handleApiError(response, $scope);
                }
                else {
                    parentScope.$emit('AddressAddedEvent', response);
                    self.Util.resetApiError($scope);
                }
                formSubmitted = false;
            });
        };
        $scope.hide = function () {
            console.log('In hide');
            $mdDialog.hide();
        };
        $scope.closeAlert = function () {
            console.log('In closeAlert of DialogController');
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            console.log('In Cancel');
            $mdDialog.cancel();
        };
        $scope.answer = function (answer) {
            if (answer == 'submitForm') {
                formSubmitted = true;
                $scope.submitForm();
            }
        };
    };
    return DropShipShippingAddressListController;
}());
export default DropShipShippingAddressListController;
//# sourceMappingURL=drop-ship-shipping-address-list.controller.js.map